import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, getStorageURL, icons, sizes } from '@/utils'

import button from '@/components/button'
import squircle from '@/components/icon/squircle'
import sticker from '@/components/sticker'

function renderIMG(h) {
  return h(
    'div',
    {
      class: 'file-sticker__image',
      directives: this.tooltip
    },
    [
      h(
        'img',
        {
          attrs: {
            src: getStorageURL([ this.file.OwnerId, this.file.id ].filter(Boolean))
          }
        }
      )
    ]
  )
}
function renderPlayer(h) {
  let icon = icons.play_arrow
  let color = Colors.primary
  if (this.playing) {
    icon = icons.pause
    color = Colors.secondary
  }

  return h(
    button,
    {
      props: {
        size: sizes.small,
        mode: buttonModes['flat-icon'],
        icon,
        color,
        tooltip: this.tooltip,
        loading: this.loading.audio
      },
      on: {
        click: () => {
          return this.toggleAudio()
        }
      }
    }
  )
}
function renderFileIcon(h) {
  return h(
    squircle,
    {
      props: {
        iconSVG: 'folder-file',
        color: this.fileMiscInfo.color,
        tooltip: this.tooltip
      }
    }
  )
}
function renderFilePreview(h) {
  switch (this.fileMiscInfo.type) {
    case 'jpg': return renderIMG.call(this, h)
    case 'wav': return renderPlayer.call(this, h)
    default: return renderFileIcon.call(this, h)
  }
}

export default function(h) {
  if (this.file) {
    return h(
      sticker,
      {
        class: 'file-sticker',
        props: this.stickerProps,
        scopedSlots: {
          icon: () => {
            return renderFilePreview.call(this, h)
          }
        }
      }
    )
  }
}
